import { styled } from '@mui/material/styles';

import { NAVBAR_HEIGHT } from 'constants/general';

export const Container = styled('div')(({ theme }) => ({
  width: '1000px',
  height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
  overflowY: 'auto',
  marginBottom: theme.spacing(4),

  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const Root = styled('div')(({ theme }) => ({
  padding: 'auto',
  position: 'relative',
  width: '100%',
  display: 'flex',
  height: '100vh',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: theme.palette.background.main,

  [theme.breakpoints.down('md')]: {
    width: 'fit-content',
    minWidth: '100%',
  },
}));
